export enum SentryEnvironment {
  Local = 'local',
  Dev = 'dev',
  Stage = 'stage',
  Uat = 'uat', // User Acceptance Testing
  Prod = 'prod',
}
